import React, { useEffect, useState, useRef } from 'react'
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { ScreenMediaDuration } from '../../../AnimatedLayouts/Create/AnimatedLayoutAdsSettings';
import { useCustomToast } from '../../../../Contexts/ToastContext';
import AdsConfirmation from './Ads/AdsConfirmation';

import _ from 'lodash';

import { ProgressSpinner } from 'primereact/progressspinner';
import { InputNumber } from 'primereact/inputnumber';
import { InputSwitch } from 'primereact/inputswitch';
import { Tooltip } from 'primereact/tooltip';

import { useScreenAds, useUpdateAdsDuration } from '../../../../../queries';
import { useUpdateLayoutAdsSettingsMutation } from '../../../../../queries';

import { setAdsSettings, setMediaDelayDuration, setScreenDetails } from '../../../../../redux/Slices/layoutSlice';
import { toggleDialog } from '../../../../../redux/Slices/Global/globalSlice';
import { useTranslation } from 'react-i18next';

const LayoutAdsSwitch = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const { isAdsOn, screens_setting } = useSelector((state) => state.layout);
    const { showToast } = useCustomToast();
    const openDialog = useSelector((state) => state.global.openDialog);

    const { mutate: enableAds, isLoading: enabling } = useUpdateLayoutAdsSettingsMutation();
    const updateAdsDuration = useUpdateAdsDuration()
    const dispatch = useDispatch()

    const turnOnAds = () => {
        enableAds({
            id: id,
        }, {
            onSuccess: () => {
                showToast('success', t('layouts.setup_layout_updating'), t('layouts.setup_ads_enabled_success'));
            }
        })
    }


    const adsOffHandler = () => {
        dispatch(setScreenDetails(screens_setting[0]))
        dispatch(setMediaDelayDuration(screens_setting[0].settings.media_delay_duration ?? 0))

        updateAdsDuration.mutateAsync({
            id: id,
            data: {
                "ads_settings": {
                    "is_ads_enabled": false
                },
            }
        }, {
            onSuccess: () => {

                showToast('success', t('layouts.setup_layout_updating'), t('layouts.setup_ads_disabled_success'));
                dispatch(toggleDialog("AdsConfirmation"))

            }
        });
    }



    const turnOffAds = () => {
        dispatch(toggleDialog("AdsConfirmation"))
    }


    return (
        <>
            <div className="flex align-items-center gap-3">
                <label className="font-large text-lg">
                    {t('layouts.setup_enable_ads_layout')}
                    <i
                        className=" switch-ads-on pi pi-question-circle text-sm cursor-pointer ml-2"
                    />
                </label>

                <InputSwitch
                    disabled={enabling || updateAdsDuration.isLoading} checked={isAdsOn}
                    onChange={(e) => isAdsOn ? turnOffAds() : turnOnAds()}
                    className="ml-auto"
                    inputId="enable-transition-switch"
                />

                <Tooltip target={`.switch-ads-on`} content={t('layouts.setup_ads_tooltip')} position='top' className="fs-8" hideDelay={300} />
            </div>
            {openDialog.AdsConfirmation ?
                <AdsConfirmation itemName={"layout"} isLoading={updateAdsDuration.isLoading} adsHandler={adsOffHandler} /> : <></>}</>
    );
};

function AdsDurations() {
    const { t } = useTranslation();
    const { id } = useParams();
    const dispatch = useDispatch()
    const location = useLocation();

    const isAnimatedLayout = location.pathname.startsWith('/apps/animated_layouts');
    const updateAdsDuration = useUpdateAdsDuration()
    const loading = updateAdsDuration.isLoading

    const { adsSettings } = useSelector((state) => state.layout);

    const [changingField, setChangingField] = useState(null);
    const [send, setSend] = useState(false);

    const sendOnkeypress = (e) => {
        setSend(true)
    }

    useEffect(() => {
        if (send) {
            updateAdsSettings()
        }
        setSend(false)
    }, [send])

    const updateAdsSettings = async (fieldName) => {
        setChangingField(fieldName);
        try {
            await updateAdsDuration.mutateAsync({
                id: id,
                data: {
                    "ads_settings": adsSettings,
                }
            }, {
                onSuccess: () => {
                }
            });
        } finally {
            setChangingField(null);
        }
    }

    return (
        <div className='bg-[#f8f6fb] rounded-lg p-2'>

            {/* adsSettings.ads_delay_duration */}
            <div className=" flex d-flex align-items-center  ">
                <div className="w-75">
                    <label className="font-large text-l">
                        {t('layouts.setup_ads_delay_duration')}
                        <i
                            className=" ads_delay_duration pi pi-question-circle text-sm cursor-pointer ml-2"
                        />
                    </label>
                    <Tooltip target=".ads_delay_duration" content={t('layouts.setup_ads_delay_tooltip')} position='top' className="fs-8" hideDelay={100} />
                </div>
                {loading && changingField === 'ads_delay_duration' ? (
                    <ProgressSpinner
                        style={{ width: '30px', height: '30px' }}
                        strokeWidth="3"
                        fill="var(--surface-ground)"
                        animationDuration="2s"
                    />
                ) : (
                    <div className="d-flex w-25 m-1 justify-content-end align-items-center">
                        <InputNumber
                            value={adsSettings.ads_delay_duration}
                            onValueChange={(e) =>
                                dispatch(setAdsSettings({ ads_delay_duration: e.value }))
                            }
                            onKeyDown={(e) => e.key === 'Enter' && sendOnkeypress(e)}
                            min={1}
                            max={86399}
                            className="p-inputtext-sm h-[30px]  "
                            inputClassName=" w-[35%]"
                            mode="decimal"
                            showButtons={false}
                        />
                        <Tooltip
                            target=".save_duration-ads_delay_duration"
                            content={t('layouts.setup_save_changes')}
                            position="bottom"
                            className="fs-8"
                        />
                        <i
                            className="col-1 mx-2 fas fa-check-circle text-lighter   cursor-pointer save_duration-ads_delay_duration"
                            onClick={() => updateAdsSettings('ads_delay_duration')}
                        ></i>
                    </div>
                )}
            </div>

            {/* adsSettings.ads_repetition_count */}
            <div className=" flex d-flex align-items-center ">
                <div className="w-75">
                    <label className="font-large text-l">
                        {t('layouts.setup_ads_repetition_count')}
                        <i
                            className=" ads_repetition_count pi pi-question-circle text-sm cursor-pointer ml-2"
                        />
                    </label>
                    <Tooltip target=".ads_repetition_count" content={t('layouts.setup_ads_repetition_tooltip')} position='top' className="fs-8" hideDelay={100} />
                </div>
                {loading && changingField === 'ads_repetition_count' ? (
                    <ProgressSpinner
                        style={{ width: '30px', height: '30px' }}
                        strokeWidth="3"
                        fill="var(--surface-ground)"
                        animationDuration="2s"
                    />
                ) : (
                    <div className="d-flex w-25 m-1 justify-content-end align-items-center">
                        <InputNumber
                            value={adsSettings.ads_repetition_count}
                            onValueChange={(e) =>
                                dispatch(setAdsSettings({ ads_repetition_count: e.value }))
                            }
                            onKeyDown={(e) => e.key === 'Enter' && sendOnkeypress(e)}
                            min={1}
                            max={100}
                            className="p-inputtext-sm  h-[30px] "
                            inputClassName=" w-[35%]"
                            mode="decimal"
                            showButtons={false}
                        />
                        <Tooltip
                            target=".save_duration-ads_repetition_count"
                            content={t('layouts.setup_save_changes')}
                            position="bottom"
                            className="fs-8"
                        />
                        <i
                            className="col-1 mx-2 fas fa-check-circle text-lighter   cursor-pointer save_duration-ads_repetition_count"
                            onClick={() => updateAdsSettings('ads_repetition_count')}
                        ></i>
                    </div>
                )}
            </div>


            {/* adsSettings.animation_duration */}
            {isAnimatedLayout && (<>
                {/* <ScreenMediaDuration /> */}
                <div className=" flex d-flex align-items-center  ">
                    <div className="w-75">
                        <label className="font-large text-l">
                            {t('layouts.setup_animation_duration')}
                            <i
                                className=" animation_duration pi pi-question-circle text-sm cursor-pointer ml-2"
                            />
                        </label>
                        <Tooltip target=".animation_duration" content={t('layouts.setup_animation_duration_tooltip')} position='top' className="fs-8" hideDelay={100} />
                    </div>
                    {loading && changingField === 'animation_duration' ? (
                        <ProgressSpinner
                            style={{ width: '30px', height: '30px' }}
                            strokeWidth="3"
                            fill="var(--surface-ground)"
                            animationDuration="2s"
                        />
                    ) : (
                        <div className="d-flex w-25 m-1 justify-content-end align-items-center">
                            <InputNumber
                                value={adsSettings.animation_duration}
                                onValueChange={(e) =>
                                    dispatch(setAdsSettings({ animation_duration: e.value }))
                                }
                                onKeyDown={(e) => e.key === 'Enter' && sendOnkeypress(e)}
                                min={1}
                                max={86399}
                                className="p-inputtext-sm h-[30px]  "
                                inputClassName=" w-[35%]"
                                mode="decimal"
                                showButtons={false}
                            />
                            <Tooltip
                                target=".save_duration-animation_duration"
                                content={t('layouts.setup_save_changes')}
                                position="bottom"
                                className="fs-8"
                            />
                            <i
                                className="col-1 mx-2 fas fa-check-circle text-lighter   cursor-pointer save_duration-animation_duration"
                                onClick={() => updateAdsSettings('animation_duration')}
                            ></i>
                        </div>
                    )}
                </div>
            </>)}

        </div>
    )
}

const ScreenAdsSwitch = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const { showToast } = useCustomToast();
    const location = useLocation();

    const { mutate: enableAds, isLoading: enabling } = useScreenAds();

    const { isAdScreen, screenDetails, media_delay_duration } = useSelector((state) => state.layout);

    const turnOnAds = () => {
        adsHandler(true)
    }

    const adsHandler = (key) => {
        enableAds({
            id: screenDetails.id,
            data: {
                "is_Ad_Screen_Enabled": key,
                "media_delay_duration": key == false ? 0 : media_delay_duration,

            }
        }, {
            onSuccess: () => {
                showToast('success', t('layouts.setup_layout_updating'), t('layouts.setup_ads_screen_switched_success'));
            }
        })
    }

    const adsDurationHandler = (key) => {
        enableAds({
            id: screenDetails.id,
            data: {
                "is_Ad_Screen_Enabled": key,
                "media_delay_duration": media_delay_duration,

            }
        }, {
            onSuccess: () => {
                showToast('success', t('layouts.setup_layout_updating'), t('layouts.setup_media_delay_success'));
            }
        })
    }
    const isAnimatedLayout = location.pathname.startsWith('/apps/animated_layouts');


    return (
        <>
            <div className="w-100 d-flex justify-content-between align-items-center me-4 mt-3 gap-3">
                <div className='d-flex align-items-center   gap-3'>
                    <span className="fs-4 bg-label-primary px-2 py-1 w-[40.8px] h-[40.8px] rounded text-center">
                        <i className="fa-solid fa-rectangle-ad fa-sm"></i>
                    </span>
                    <div>
                        <span className="text-xs">{t('layouts.setup_screen_type')}: {isAdScreen ? t('layouts.setup_ad_type') : t('layouts.setup_static_type')} </span>
                        <h5 className=" ">{t('layouts.setup_ad_screen')}</h5>
                    </div>
                </div>
                <div className='d-flex align-items-center   gap-3'>
                    <InputSwitch disabled={enabling || enabling} checked={isAdScreen}
                        onChange={(e) => isAdScreen ? adsHandler(false) : turnOnAds()} />
                </div>
            </div>

            {(isAdScreen && !isAnimatedLayout) &&
                (<div className='bg-[#f8f6fb] rounded-lg p-2'>

                    {/* media_delay_duration */}
                    <div className=" flex d-flex align-items-center ">
                        <div className="w-75">
                            <label className="font-large text-l">
                                {t('layouts.setup_media_delay_duration')}
                                <i
                                    className=" media_delay_duration pi pi-question-circle text-sm cursor-pointer ml-2"
                                />
                            </label>
                            <Tooltip target=".media_delay_duration" content={t('layouts.setup_media_delay_tooltip')} position='top' className="fs-8" hideDelay={100} />
                        </div>
                        {enabling ? (
                            <ProgressSpinner
                                style={{ width: '30px', height: '30px' }}
                                strokeWidth="3"
                                fill="var(--surface-ground)"
                                animationDuration="2s"
                            />
                        ) : (
                            <div className="d-flex w-25 m-1 justify-content-end align-items-center">
                                <InputNumber
                                    value={media_delay_duration}
                                    onValueChange={(e) =>
                                        dispatch(setMediaDelayDuration(e.value))
                                    }
                                    onKeyDown={(e) => e.key === 'Enter' && dispatch(setMediaDelayDuration(e.value))
                                    }
                                    min={0}
                                    max={100}
                                    className="p-inputtext-sm  h-[30px] "
                                    inputClassName=" w-[35%]"
                                    mode="decimal"
                                    showButtons={false}
                                />
                                <Tooltip
                                    target=".save_duration-media_delay_duration"
                                    content={t('layouts.setup_save_changes')}
                                    position="bottom"
                                    className="fs-8"
                                />
                                <i
                                    className="col-1 mx-2 fas fa-check-circle text-lighter   cursor-pointer save_duration-media_delay_duration"
                                    onClick={() => adsDurationHandler(true)}
                                ></i>
                            </div>
                        )}
                    </div>
                </div>)
            }
        </>
    );
};

export { LayoutAdsSwitch, AdsDurations, ScreenAdsSwitch };